__turbopack_context__.v({
  "arrow": "ScienceSection-module__1WtOzq__arrow",
  "card": "ScienceSection-module__1WtOzq__card",
  "cardBody": "ScienceSection-module__1WtOzq__cardBody",
  "cardImage": "ScienceSection-module__1WtOzq__cardImage",
  "cardStack": "ScienceSection-module__1WtOzq__cardStack",
  "cardTitle": "ScienceSection-module__1WtOzq__cardTitle",
  "description": "ScienceSection-module__1WtOzq__description",
  "header": "ScienceSection-module__1WtOzq__header",
  "heading": "ScienceSection-module__1WtOzq__heading",
  "inner": "ScienceSection-module__1WtOzq__inner",
  "meta": "ScienceSection-module__1WtOzq__meta",
  "metaDate": "ScienceSection-module__1WtOzq__metaDate",
  "metaPrimary": "ScienceSection-module__1WtOzq__metaPrimary",
  "metaSeparator": "ScienceSection-module__1WtOzq__metaSeparator",
  "readMore": "ScienceSection-module__1WtOzq__readMore",
  "section": "ScienceSection-module__1WtOzq__section",
});
